import React from 'react'
import { Outlet, Link, useLocation } from 'react-router-dom'
import {
  HomeIcon,
  CalendarIcon,
  BookOpenIcon,
  UserIcon,
  WrenchScrewdriverIcon
} from '@heroicons/react/24/outline'
import {
  HomeIcon as HomeIconSolid,
  CalendarIcon as CalendarIconSolid,
  BookOpenIcon as BookOpenIconSolid,
  UserIcon as UserIconSolid,
  WrenchScrewdriverIcon as WrenchScrewdriverIconSolid
} from '@heroicons/react/24/solid'

interface LayoutProps {
  children?: React.ReactNode
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation()

  // 底部导航栏项目
  const navItems = [
    { 
      id: 'home', 
      name: '首页', 
      href: '/dashboard', 
      icon: HomeIcon, 
      activeIcon: HomeIconSolid 
    },
    { 
      id: 'booking', 
      name: '预约', 
      href: '/booking', 
      icon: CalendarIcon, 
      activeIcon: CalendarIconSolid 
    },
    { 
      id: 'materials', 
      name: '教材', 
      href: '/materials', 
      icon: BookOpenIcon, 
      activeIcon: BookOpenIconSolid 
    },
    { 
      id: 'software-tools', 
      name: '工具', 
      href: '/software-tools', 
      icon: WrenchScrewdriverIcon, 
      activeIcon: WrenchScrewdriverIconSolid 
    },
    { 
      id: 'profile', 
      name: '我的', 
      href: '/profile', 
      icon: UserIcon, 
      activeIcon: UserIconSolid 
    },
  ]

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/')
  }

  return (
    <div className="min-h-screen bg-slate-50 pb-20">
      {/* 页面内容 */}
      <main className="flex-1">
        {children || <Outlet />}
      </main>

      {/* 底部导航栏 - 专业简洁风格 */}
      <nav className="bottom-nav">
        <div className="max-w-lg mx-auto">
          <div className="flex justify-around items-center h-14">
            {navItems.map((item) => {
              const active = isActive(item.href)
              const Icon = active ? item.activeIcon : item.icon
              
              return (
                <Link
                  key={item.id}
                  to={item.href}
                  className={`bottom-nav-item relative ${active ? 'active' : ''}`}
                >
                  {/* 活跃状态指示器 */}
                  {active && (
                    <span className="absolute -top-0.5 left-1/2 -translate-x-1/2 w-5 h-1 bg-primary-500 rounded-full" />
                  )}
                  
                  <Icon className={`w-6 h-6 transition-colors ${
                    active ? 'text-primary-600' : 'text-slate-400'
                  }`} />
                  
                  <span className={`text-[10px] mt-0.5 font-medium transition-colors ${
                    active ? 'text-primary-600' : 'text-slate-400'
                  }`}>
                    {item.name}
                  </span>
                </Link>
              )
            })}
          </div>
        </div>
      </nav>
    </div>
  )
}
